<template lang="pug">
.read-more
  span(v-html="compiled")
  a(
    v-if="hasMore && !settings.more"
    @click="settings.more = !settings.more"
    href="javascript:;"
    class="button is-light is-small"
  ) Read {{ settings.more ? 'Less' : 'More' }}
</template>

<script>
import marked from 'marked';

export default {
  name: 'read-more',
  computed: {
    compiled() {
      return marked(this.content);
    },
    content() {
      if (this.string === null) return '';
      if (this.length === 0) return this.string;
      if (this.settings.more || this.string.length <= this.length) return this.string;
      const sub = this.string.substr(0, this.string.lastIndexOf(' ', this.length));
      return `${sub}. . .`;
    },
    hasMore() {
      if (this.string === null || this.length === 0) return false;
      return this.string.length > this.length;
    },
  },
  created() {
    this.string = this.value;
  },
  data() {
    return {
      settings: {
        more: false,
      },
      string: null,
    };
  },
  props: {
    length: {
      type: Number,
      default: 220,
    },
    value: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.read-more {
  .button {
    margin-top: 1rem;
  }
}
</style>
